module.exports = __webpack_public_path__ + "img/neotag-recovery-card-dark.0e680f20.png";